<template>
  <div class="app-container">
    <h3>负责课程考试</h3>
    <el-alert v-if="error" :title="error" type="error" :closable="false" show-icon />
    <el-button size="small" :loading="loading" @click="load">刷新</el-button>
    <template v-if="context">
      <p>{{ context.lecturerName }} · 仅展示本人负责课程。次数统计仅含已交卷答卷，作废答卷不计入。</p>
      <el-alert v-if="!context.canReadPersonal" title="当前仅可查看课程汇总，未授予个人答卷查看权限。" type="info" :closable="false" show-icon />
      <el-table :data="rows" v-loading="loading" border :empty-text="error ? '查询未成功，请重试' : '暂无负责课程'" class="summary-table">
        <el-table-column prop="subjectName" label="课程" min-width="180" />
        <el-table-column prop="examCount" label="配置考试数" width="110" />
        <el-table-column prop="participantCount" label="参考人数" width="100" />
        <el-table-column prop="submittedCount" label="已交卷次数" width="110" />
        <el-table-column prop="passedCount" label="通过次数" width="100" />
        <el-table-column label="操作" width="140">
          <template slot-scope="{row}">
            <el-button type="text" :disabled="!context.canReadPersonal" @click="open(row)">查看个人答卷</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog :title="selected ? selected.subjectName + ' · 考试记录' : '考试记录'" :visible.sync="visible" width="95%" top="4vh" append-to-body destroy-on-close>
        <after-class v-if="visible && selected && context.canReadPersonal" :key="selected.subjectId" lecturer-mode :subject-id="selected.subjectId" />
      </el-dialog>
    </template>
  </div>
</template>
<script>
import api from '@/api/course/courseExamLecturer'
import AfterClass from './afterClass'
export default {
  name: 'LecturerExamSummary',
  components: { AfterClass },
  data: () => ({ context: null, rows: [], error: '', loading: false, selected: null, visible: false, seq: 0 }),
  mounted() { this.load() },
  beforeDestroy() { this.seq++ },
  methods: {
    async load() {
      const seq = ++this.seq
      this.loading = true
      this.error = ''
      this.context = null
      this.rows = []
      this.visible = false
      try {
        const { data: context } = await api.context()
        const { data: rows } = await api.summary()
        if (seq !== this.seq) return
        this.context = context
        this.rows = rows || []
      } catch (err) {
        if (seq === this.seq) this.error = (err && err.message) || '负责课程考试加载失败，请重试'
      } finally { if (seq === this.seq) this.loading = false }
    },
    open(row) {
      if (!this.context || !this.context.canReadPersonal) return
      this.selected = row
      this.visible = true
    }
  }
}
</script>
<style scoped>
.summary-table { margin-top: 14px; }
p { color: #606266; line-height: 1.6; }
</style>
